import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getAuthSnapshot } from '@/context/auth/deriveAuth';
import { normalizeAuthRedirectLink } from '@/utils/authRedirectLink';

export const Route = createFileRoute('/_authenticated')({
  component: Outlet,
  validateSearch: (search: Record<string, unknown>) => {
    const link = normalizeAuthRedirectLink(search.link);
    if (link) {
      return {
        link,
      };
    }

    delete search.link;
    return {};
  },
  beforeLoad: async ({ location, search }) => {
    if (!getAuthSnapshot().isAuthenticated) {
      throw redirect({
        to: '/sign-in',
        search: { link: normalizeAuthRedirectLink(search.link) ?? location.href },
      });
    }
  },
});
